import Component from "../../../../../Component";
import { ViewState } from "./_reducers";

export { reducers } from "./_reducers";

interface ComponentState {
    status: string;
    loadText: string;
}

const widgetKey: any = {
    compassWidget: "esri/widgets/Compass",
    homeWidget: "esri/widgets/Home",
    legendWidget: "esri/widgets/Legend",
    locateWidget: "esri/widgets/Locate",
    searchWidget: "esri/widgets/Search",
    expandWidget: "esri/widgets/Expand"
};

export default class ViewBase extends Component<ViewState, ComponentState> {
    constructor(props: __Component.Props) {
        super(props);

        this.state = {
            status: "loading",
            loadText: "scripts"
        };

        this.loadScripts = this.loadScripts.bind(this);
        this.loadMap = this.loadMap.bind(this);
        this.loadWidgets = this.loadWidgets.bind(this);

        this.loadScripts.bind(this)();
    }

    public render() {
        const tsx = this.tsx;

        if (this.state.status === "loaded") {
            return <div />;
        } else if (this.state.status === "loading") {
            return (
                <div>
                    <div class="loader is-active padding-leader-3 padding-trailer-3 center-style">
                        <div class="loader-bars" />
                        <div class="loader-text">{this.props.i18n.viewLoading[this.state.loadText]}</div>
                    </div>
                </div>
            );
        }
        return (
            <div>
                <h3 class="center-style">{this.props.i18n.viewLoading.failed}</h3>
            </div>
        );
    }

    private loadScripts() {
        return new Promise(
            (resolve: (value: any[]) => void, reject) => { 
                require(["esri/WebMap", "esri/WebScene", "esri/views/MapView", "esri/views/SceneView"], 
                        (WebMap, WebScene, MapView, SceneView) => {
                            return resolve([WebMap, WebScene, MapView, SceneView]);
                        }
                ); 
            }).then(([WebMap, WebScene, MapView, SceneView]) => {
                const webModule = this.props.webModule === "esri/WebMap" ? WebMap :
                          this.props.webModule === "esri/WebScene" ? WebScene : 
                          WebMap; // default to WebMap
                const viewModule = this.props.viewModule === "esri/views/MapView" ? MapView :
                                this.props.viewModule === "esri/views/SceneView" ? SceneView :
                                MapView; // default to MapView
                this.setState({ loadText: "map" });
                this.loadMap(webModule, viewModule);  
            });
    }

    private loadMap(
        WebConstructor: __esri.WebMapConstructor | __esri.WebSceneConstructor,
        ViewConstructor: __esri.MapViewConstructor | __esri.SceneViewConstructor
    ) {
        let view: any;
        const map: __esri.WebMap | __esri.WebScene = new WebConstructor({
            portalItem: {
                id: this.props.id
            }
        });
        map.load().then(() => {
            this.setState({ loadText: "basemap" });
            return map.basemap.load();
        }).then(() => {
            this.setState({ loadText: "layers" });
            const allLayers = map.allLayers;
            const promises = allLayers.map((layer) => layer.load());
            return Promise.all(promises.toArray() as any).then((r: any) => r as any); // Magic to avoid type errors
        }).then((layers) => {
            this.setState({ loadText: "widgets" });
            view = new ViewConstructor({
                container: this.props.containerId,
                map
            });
            return this.loadWidgets(view);
        }).then(
            () => {
                view.container = this.props.containerId;
                this.setState({ status: "loaded" });  
            },  (err) => {
                this.setState({ status: "failed" });
            }
        );
    }

    private loadWidgets(view: __esri.MapView) {
        const positions = {
            "bottom-left": true,
            "bottom-right": true,
            "top-left": true,
            "top-right": true
        };
        const modules = Object.keys(this.props.widgets).reduce((p, c, i) => {
            if (positions[this.props.widgets[c]]) {
                p.push({
                    module: widgetKey[c],
                    position: this.props.widgets[c]
                } as never); // typescript is weird
            }
            return p;
        },                                                     []);
        let constructorKey: object = {};
        return new Promise(
            (resolve: (value: any[]) => void, reject) => { 
                require(["esri/widgets/Compass", "esri/widgets/Home", "esri/widgets/Legend", "esri/widgets/Locate", "esri/widgets/Search", "esri/widgets/Expand"], 
                        (Compass, Home, Legend, Locate, Search, Expand) => {
                            constructorKey = {
                                "esri/widgets/Compass": Compass, 
                                "esri/widgets/Home": Home, 
                                "esri/widgets/Legend": Legend, 
                                "esri/widgets/Locate": Locate, 
                                "esri/widgets/Search": Search, 
                                "esri/widgets/Expand": Expand
                            };
                            return resolve([Compass, Home, Legend, Locate, Search, Expand]);
                        }
                ); 
            }).then(([Compass, Home, Legend, Locate, Search, Expand]) => {
                modules.forEach((mod) => {
                    if (!!mod["module"]) {
                        const constructor: any = constructorKey[mod["module"]];
                        let widget = new constructor({ view });
                        if ( mod["module"] === "esri/widgets/Legend" ) {
                            // create expand widget to go around legend
                            widget = new Expand({
                                expandIconClass: widget.iconClass || "esri-icon-layer-list",
                                view: view, 
                                content: widget
                            });
                        }
                        if (widget.activeLayerInfos) {
                            widget.watch("activeLayerInfos.length", () => {
                                view.ui.add(widget, mod["position"]);
                            });
                            return;
                        }
                        view.ui.add(widget, mod["position"]);
                    }
                });
                return Promise.resolve();
            },      (err) => {
                console.error("Widget Loading Error: \n", err);
            }
        );
        // return promise;
    }
}


// WEBPACK FOOTER //
// ./src/mainApp/MinimalGallery/Viewer/View/ViewBase/index.tsx